<template>
  <v-dialog
    max-width="720px"
    v-model="getModalCadastroLancamentoCaixa"
    persistent
  >
    <v-card outlined :loading="$store.getters.getOverlay">
      <v-card-title> Cadastro de Lançamento de Caixa</v-card-title>
      <v-form ref="formLancamentoCaixa" class="px-3">
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 md12>
              <v-text-field
                v-model="getLancamentoCaixa.data"
                label="Data"
                outlined
                dense
                class="mr-2 ml-2"
                required
                type="date"
                :rules="rules.data"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md12>
              <v-select
                :items="getLancamentoCaixaTipos"
                v-model="getLancamentoCaixa.tipo"
                label="Tipo"
                outlined
                dense
                class="mr-2 ml-2"
                required
                :rules="rules.tipo"
              ></v-select>
            </v-flex>
            <v-flex xs12 md12>
              <v-select
                :items="getFormasPagamento"
                v-model="getFormaPagamentoSelecionadaLancamentoCaixa"
                label="Forma de Pagamento"
                item-value="id"
                item-text="nome"
                outlined
                dense
                class="mr-2 ml-2"
                return-object
                @change="selecionaFormaPagamento"
                :rules="rules.forma_pagamento"
              ></v-select>
            </v-flex>
            <v-flex xs12 md12>
              <v-text-field
                label="Valor"
                v-model="getLancamentoCaixa.valor"
                v-mask="[
                  '#,##',
                  '##,##',
                  '###,###',
                  '#.###,##',
                  '##.###,##',
                  '###.###,##',
                ]"
                outlined
                dense
                class="mr-2 ml-2"
                required
                :rules="rules.valor"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md12>
              <v-text-field
                outlined
                dense
                class="mr-2 ml-2"
                v-model="getLancamentoCaixa.historico"
                label="Histórico"
                required
                :rules="rules.historico"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-form>

        <v-card-actions>
          <v-btn
            color="default"
            @click="setModalCadastroLancamentoCaixa(false)"
            outlined
            >Voltar</v-btn
          >
          <v-btn
            color="primary"
            v-if="
              getLancamentoCaixa.id &&
              $helper.verificaPermissao('cadastrar-lancamento-caixa')
            "
            @click="cadastrarLancamentoCaixa"
            outlined
            >Novo</v-btn
          >
          <v-btn
            color="error"
            v-if="
              getLancamentoCaixa.id &&
              $helper.verificaPermissao('excluir-lancamento-caixa')
            "
            @click="setModalExcluirLancamentoCaixa(true)"
            outlined
            >Excluir</v-btn
          >
          <v-btn
            color="default"
            @click="impimirLancamentoCaixa(getLancamentoCaixa.id)"
            outlined
            >Imprimir</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            @click="salvar()"
            :loading="$store.getters.getOverlay"
            outlined
            v-if="
              $helper.verificaPermissao('cadastrar-lancamento-caixa') ||
              $helper.verificaPermissao('atualizar-lancamento-caixa')
            "
            >Salvar</v-btn
          >
        </v-card-actions>
    </v-card>
    <ModalExcluir />
  </v-dialog>
</template>

<script>
import ModalExcluir from "@/pages/caixa/lancamento/ModalExcluir";
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    ModalExcluir,
  },
  computed: {
    ...mapGetters([
      "getLancamentoCaixa",
      "getModalCadastroLancamentoCaixa",
      "getFormasPagamento",
      "getLancamentoCaixaTipos",
      "getFormaPagamentoSelecionadaLancamentoCaixa",
    ]),
  },
  data() {
    return {
      formaPagamentoSelecionada: "",
      rules: {
        data: [(v) => !!v || "Campo obrigatório."],
        tipo: [(v) => !!v || "Campo obrigatório."],
        forma_pagamento: [(v) => !!v || "Campo obrigatório."],
        valor: [(v) => !!v || "Campo obrigatório."],
        historico: [(v) => !!v || "Campo obrigatório."],
      },
    };
  },

  methods: {
    ...mapActions([
      "setModalCadastroLancamentoCaixa",
      "setModalExcluirLancamentoCaixa",
      "cadastrarLancamentoCaixa",
      "salvarLancamentoCaixa",
      "atualizarLancamentoCaixa",
      "listarFormaPagamento",
      "setFormaPagamentoSelecionadaLancamentoCaixa",
      "impimirLancamentoCaixa",
    ]),
    salvar() {
      if (this.$refs.formLancamentoCaixa.validate() == false) {
        return;
      }
      this.getLancamentoCaixa.forma_pagamento = this.getFormaPagamentoSelecionadaLancamentoCaixa.nome;
      this.getLancamentoCaixa.forma_pagamento_id = this.getFormaPagamentoSelecionadaLancamentoCaixa.id;
      if (this.getLancamentoCaixa.id) {
        this.atualizarLancamentoCaixa(this.getLancamentoCaixa);
      } else {
        this.salvarLancamentoCaixa(this.getLancamentoCaixa);
      }
    },
    selecionaFormaPagamento(e) {
      this.$store.commit("setFormaPagamentoSelecionadaLancamentoCaixa", e);
    },
  },
  created() {
    this.listarFormaPagamento();
  },
};
</script>